module.exports = __webpack_public_path__ + "img/clinicimg5.76550c69.jpg";